module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pt",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PRELUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All day, all day I brush")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("My golden strands of hair;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("All day I wait and wait …")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Ah, who is there?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Who calls? Who calls? The gold")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ladder of my long hair")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I loose and wait … and wait …")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Ah, who is there?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She left at dawn … I am blind")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In the tangle of my long hair …")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Is it she? the witch? the witch?")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Ah, who is there?")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("‘Rapunzel’")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Adelaide Crapsey")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0